import { render, staticRenderFns } from "./UnidadesConsumidoras.vue?vue&type=template&id=74d933d4"
import script from "./UnidadesConsumidoras.vue?vue&type=script&lang=js"
export * from "./UnidadesConsumidoras.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports